import React from "react";
import {connect} from "react-redux";
import {FormattedMessage} from "react-intl";
import {
  SIDEBAR_SHAPE_BUTTONS,
  SIDEBAR_NAVIGATION_CABINET_BUTTONS,
  SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS,
  SIDEBAR_HIDDEN_BUTTONS,
  FREE_FORM_THICKNESS_POPUP_ID
} from "../../constants";
import FreeDraw from "../canvas/core/controls/freeDraw";
import toolsControllers from "../canvas/store/toolsControllers";
import ChangeValuePopupWindow from "./ChangeValuePopupWindow";

const DrawingShortcuts = ({activeButton, depthPopup, isMobile}) => {
  const isFreeForm = activeButton === SIDEBAR_SHAPE_BUTTONS.shapeFreeForm;
  const isWall = activeButton === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall;
  const isDrawing = isFreeForm || isWall || [
    SIDEBAR_SHAPE_BUTTONS.freeDraw,
    SIDEBAR_TYPE_AREA_NAVIGATION_BUTTONS.freeDraw,
    SIDEBAR_HIDDEN_BUTTONS.buttonBacksplashFreeDraw
  ].includes(activeButton);
  if (!isDrawing || (isMobile && (!isFreeForm || !depthPopup))) {
    return null;
  }

  const handleUndo = () => {
    const drawingTool = isFreeForm ? toolsControllers.shapeFreeForm : FreeDraw;
    drawingTool.undoLastPoint();
  };

  return (
    <aside className={"drawing-shortcuts" + (isMobile ? " drawing-shortcuts--parameter-only" : "")}>
      {isFreeForm && depthPopup ? <ChangeValuePopupWindow {...depthPopup} isInline /> : null}
      {!isMobile ? <>
      <div className="drawing-shortcuts__title">
        <FormattedMessage id="sqft.drawing.shortcuts" defaultMessage="Drawing shortcuts" />
      </div>
      <div className="drawing-shortcuts__finish">
        <div className="drawing-shortcuts__hint">
          <span className="drawing-shortcuts__label">
            <FormattedMessage id="sqft.drawing.finish" defaultMessage="Finish drawing" />
          </span>
        <span className="drawing-shortcuts__keys">
          <kbd className="drawing-shortcuts__key">Enter</kbd>
            <span>/</span>
            <kbd className="drawing-shortcuts__key"><FormattedMessage id="sqft.drawing.rightClick" defaultMessage="Right-click" /></kbd>
        </span>
        </div>
        {!isFreeForm && !isWall ? (
          <div className="drawing-shortcuts__note">
            <FormattedMessage id="sqft.drawing.closeShape" defaultMessage="Or click the first point to close the shape." />
          </div>
        ) : null}
      </div>
      <button type="button" className="drawing-shortcuts__hint drawing-shortcuts__undo" onClick={handleUndo}>
        <FormattedMessage id="sqft.drawing.undo" defaultMessage="Undo last step" />
        <kbd className="drawing-shortcuts__key">Ctrl / ⌘ Z</kbd>
      </button>
      </> : null}
    </aside>
  );
};

export default connect(state => ({
  activeButton: state.sqftMenuState.activeButton,
  isMobile: state.serverState.isMobile,
  depthPopup: state.sqftMenuState.changeValuePopups.find(popup => popup.id === FREE_FORM_THICKNESS_POPUP_ID)
}))(DrawingShortcuts);
